import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectSimple, Input, Row, Label, useFormikContext, FieldError } from '@mssgme/ui';

export const CATEGORIES = [
    {
        label: 'categoriesList.category_not_business',
        value: 'category_not_business',
    },
    {
        label: 'categoriesList.category_auto',
        value: 'category_auto',
    },
    {
        label: 'categoriesList.category_meal',
        value: 'category_meal',
    },
    {
        label: 'categoriesList.category_health',
        value: 'category_health',
    },
    {
        label: 'categoriesList.category_noncommercial',
        value: 'category_noncommercial',
    },
    {
        label: 'categoriesList.category_education',
        value: 'category_education',
    },
    {
        label: 'categoriesList.category_social_services',
        value: 'category_social_services',
    },
    {
        label: 'categoriesList.category_cloth',
        value: 'category_cloth',
    },
    {
        label: 'categoriesList.category_events_organization',
        value: 'category_events_organization',
    },
    {
        label: 'categoriesList.category_hotels_rent',
        value: 'category_hotels_rent',
    },
    {
        label: 'categoriesList.category_sales',
        value: 'category_sales',
    },
    {
        label: 'categoriesList.category_pro_services',
        value: 'category_pro_services',
    },
    {
        label: 'categoriesList.category_travel_logistics',
        value: 'category_travel_logistics',
    },
    {
        label: 'categoriesList.category_entertainment',
        value: 'category_entertainment',
    },
    {
        label: 'categoriesList.category_restaurants',
        value: 'category_restaurants',
    },
    {
        label: 'categoriesList.category_beauty_spa',
        value: 'category_beauty_spa',
    },
    {
        label: 'categoriesList.category_finance',
        value: 'category_finance',
    },
];

export function CategoryChoice({ value, ...rest }) {
    // todo: move translations into @mssgme/cards package when Onboarding is removed
    const { t } = useTranslation();

    const options = useMemo(() => {
        const categories = CATEGORIES.map((c) => ({ ...c, label: t(c.label) })).sort((a, b) =>
            a === b ? 0 : a > b ? -1 : 1
        );
        categories.push({ label: t('categoriesList.category_other'), value: '' });
        return categories;
    }, [t]);

    return <SelectSimple options={options} value={value} {...rest} />;
}

CategoryChoice.propTypes = {
    value: PropTypes.string,
};

export function CategoryField({ id, name, label, extra = {}, ...rest }) {
    const { t } = useTranslation('cards');
    const { getFieldProps, getFieldMeta } = useFormikContext(name);
    const { value, onChange, onBlur } = getFieldProps(name);
    const { error } = getFieldMeta(name);
    const isPredefined = useMemo(() => CATEGORIES.some((o) => o.value === value), [value]);

    return (
        <>
            <Row>
                {label && <Label htmlFor={id}>{label}</Label>}
                <CategoryChoice
                    id={id}
                    name={name}
                    value={isPredefined ? value : ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    {...rest}
                />
                {isPredefined && error && <FieldError>{t(error)}</FieldError>}
            </Row>
            {!isPredefined && (
                <Row>
                    {extra.label && <Label htmlFor={`${id}_custom`}>{extra.label}</Label>}
                    <Input
                        id={`${id}_custom`}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        {...extra}
                    />
                    {error && <FieldError>{t(error)}</FieldError>}
                </Row>
            )}
        </>
    );
}

CategoryField.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    extra: PropTypes.shape({
        label: PropTypes.string,
    }),
};
